


























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import BirthdaysOverview from "./BirthdaysOverview.vue";
import BirthdaysRequests from "./BirthdaysRequests.vue";
import BirthdaysBookings from "./BirthdaysBookings.vue";
import BirthdaysPayments from "./BirthdaysPayments.vue";
import BirthdaysStaffFreeDates from "./BirthdaysStaffFreeDates.vue";
import BirthdaysCalendar from "./BirthdaysCalendar.vue";
import BirthdaysAll from "./BirthdaysAll.vue";
import BirthdaysMyBirthdays from "./BirthdaysMyBirthdays.vue";
import BirthdaysStaffBirthdays from "./BirthdaysStaffBirthdays.vue";
import BirthdaysPrograms from "./BirthdaysPrograms.vue";

import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Birthdays",
  components: {
    MainTabbar,
    BirthdaysOverview,
    BirthdaysRequests,
    BirthdaysBookings,
    BirthdaysPayments,
    BirthdaysStaffFreeDates,
    BirthdaysCalendar,
    BirthdaysAll,
    BirthdaysMyBirthdays,
    BirthdaysStaffBirthdays,
    BirthdaysPrograms,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      currentMainTabbarTab: "",
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
      BirthdayBookingStatusNames: {
        requestedStaffRequired: "Betreuer:in benötigt",
        requestedNoStaffAvailable: "Kein:e Betreuer:in verfügbar",
        requestedPendingConfirmation: "Bestätigung benötigt",
        offerToCustomer: "Kundenbestätigung abwarten",
        booked: "Gebucht und bestätigt",
        readyForPayment: "Bereit für Bezahlung",
        paymentExported: "Rechnung wurde exportiert",
        cancellationPending: "Abgesagt, Bestätigung benötigt",
        canceled: "Abgesagt, Gebühr-Export ausstehend",
        cancellationFeeExported: "Abgesagt, Gebühr wurde exportiert",
      },
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Übersicht",
          linkedComponent: "BirthdaysOverview",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Anfragen",
          linkedComponent: "BirthdaysRequests",
          permissionRank: 1,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 1, UserPermissionType.moduleBirthdays),
          isDisplayed: vue.checkPermission(vue.loginUser, 1, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Buchungen",
          linkedComponent: "BirthdaysBookings",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Kalender",
          linkedComponent: "BirthdaysCalendar",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Alle Geburtstage",
          linkedComponent: "BirthdaysAll",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Zahlungen",
          linkedComponent: "BirthdaysPayments",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
        },
        {
          title: "Meine Termine",
          linkedComponent: "BirthdaysStaffFreeDates",
          permissionRank: 1,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 1, UserPermissionType.moduleBirthdays),
          isDisplayed: vue.checkPermission(vue.loginUser, 1, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Meine Geburtstage",
          linkedComponent: "BirthdaysMyBirthdays",
          permissionRank: 1,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 1, UserPermissionType.moduleBirthdays),
          isDisplayed: vue.checkPermission(vue.loginUser, 1, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Betreuer Termine",
          linkedComponent: "BirthdaysStaffBirthdays",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Programme",
          linkedComponent: "BirthdaysPrograms",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
        },
      ] as ModulesJson[];
    },
  },
});
